/**
 * @file
 * Attaches behaviors for Reset Button for Views.
 */

!((document, $) => {
  'use strict';
  Drupal.behaviors.SeDeplacerAutrementToggle = {
    attach: function attach(context) {
      let $blockContainer = $(context).find('.se-deplacer-autrement-container.collapsible');

      if ($blockContainer) {
        $($blockContainer).find('.se-deplacer-title').on('click', function() {
          let el = $('.se-deplacer-links');
          let icon = $('.uk-icon.triangle');

          el.toggle('fast');
          icon.toggleClass('rotated');
        });
      }
    }
  };
})(document, jQuery);
